import './index.css';

const hasOpenModal = 'has-openModal';
const modalComponent = '.c-modal';
const modalClose = '.js-closeModal';
const modalOpen = '.js-openModal';
const modalShow = 'js-modalShow';

document.addEventListener('DOMContentLoaded', () => {
  const openModalButtons = document.querySelectorAll(modalOpen);
  const closeModalButtons = document.querySelectorAll(modalClose);
  const modals = document.querySelectorAll(modalComponent);

  openModalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modalId = button.getAttribute('data-modal-id');
      const modal = document.getElementById(modalId);

      modal.style.display = 'block';

      setTimeout(() => {
        modal.classList.add(modalShow);
      }, 10);

      document.body.classList.add(hasOpenModal);
    });
  });

  closeModalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest(modalComponent);

      modal.classList.remove(modalShow);

      setTimeout(() => {
        modal.style.display = 'none';
      }, 300);

      document.body.classList.remove(hasOpenModal);
    });
  });

  window.addEventListener('click', (event) => {
    modals.forEach((modal) => {
      if (event.target === modal) {
        modal.classList.remove(modalShow);

        setTimeout(() => {
          modal.style.display = 'none'; // eslint-disable-line no-param-reassign
        }, 300);

        document.body.classList.remove(hasOpenModal);
      }
    });
  });

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      modals.forEach((modal) => {
        if (modal.style.display === 'block') {
          modal.classList.remove(modalShow);

          setTimeout(() => {
            modal.style.display = 'none'; // eslint-disable-line no-param-reassign
          }, 300);

          document.body.classList.remove(hasOpenModal);
        }
      });
    }
  });
});
